<template>
  <section class="ref-chapter-3">
    <RefAnchorNav :section="3" />
    <Footer />
    <img src="@/assets/fes-corn-wave.svg" class="footer-corn"/>
  </section>  
</template>

<script>
import Footer from '@/components/layout/Footer'
import RefAnchorNav from '@/components/layout/RefAnchorNav'

export default {
  name: 'RefChapter3',
  components: {
    Footer,
    RefAnchorNav    
  },
}
</script>

<style lang="scss" scoped>
.ref-chapter-3 {
  padding: 96px 0;
  background: #E9ECFB;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 48px 4px;
  }  

  .footer-corn {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 35vw;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      width: 100%;
      position: relative;
      bottom: -48px;
    }    
  }  
}
</style>